import {
  AUTH_LOGOUT,
  AUTH_SUCCESS,
  SAVE_RECAPTCHA_TOKEN
} from '../actions/constantsActions';

const initialState = {
  id: null,
  email: null,
  firstName: null,
  lastName: null,
  userName: null,
  jwtToken: null,
  recaptchaToken: null,
  roles: {}
};

const authReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case AUTH_SUCCESS:
      return {
        ...state,
        ...{
          id: payload.id,
          email: payload.email,
          firstName: payload.firstName,
          lastName: payload.lastName,
          userName: payload.userName,
          jwtToken: payload.jwtToken,
          roles: payload.roles
        }
      };
    case AUTH_LOGOUT:
      return {
        ...state,
        ...initialState
      };
    case SAVE_RECAPTCHA_TOKEN:
      return {
        ...state,
        ...{
          recaptchaToken: payload
        }
      };
    default:
      return state;
  }
};

export default authReducer;
